export const transformAmountForQR = (value: string | number): number => {
  if (typeof value === 'number') {
    return Math.round(value * 100)
  }
  const cleanedValue = value?.replace(',', '.')

  return Math.round(parseFloat(cleanedValue) * 100)
}
